import { render, staticRenderFns } from "./billing.view.vue?vue&type=template&id=cbdb61c4&scoped=true&"
import script from "./billing.view.vue?vue&type=script&lang=ts&"
export * from "./billing.view.vue?vue&type=script&lang=ts&"
import style0 from "./billing.view.vue?vue&type=style&index=0&id=cbdb61c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb61c4",
  null
  
)

export default component.exports